import { ArrowPathIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useForm } from "@inertiajs/react";
import type { FormEvent } from "react";
import { useEffect, useRef, useState } from "react";

type EmailSignInFormProps = {
  auditUrl?: string | null;
};

export default function EmailSignInForm({ auditUrl }: EmailSignInFormProps) {
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const auditHandoff = Boolean(auditUrl);
  const { data, processing, setData, post } = useForm({
    email: "",
    audit_url: auditUrl ?? "",
  });

  useEffect(() => {
    if (!expanded) return;
    inputRef.current?.focus();
  }, [expanded]);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    post("/auth-token");
  }

  if (!expanded) {
    return (
      <div className="text-center">
        <button
          type="button"
          className="cursor-pointer text-base font-medium text-primary underline hover:text-primary/80"
          onClick={() => setExpanded(true)}
          data-testid="email-auth-expand"
        >
          Continue with email
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="email-auth-form">
      {auditHandoff ? <input name="audit_url" type="hidden" value={data.audit_url} /> : null}
      <div>
        <label htmlFor="email" className="sr-only">
          Email address
        </label>
        <input
          ref={inputRef}
          id="email"
          data-testid="email-input"
          className="field-input py-3"
          type="email"
          autoComplete="email"
          placeholder="Enter your email address"
          required
          value={data.email}
          onChange={(event) => setData("email", event.target.value)}
        />
      </div>

      <button
        id="email-submit"
        data-testid="email-submit"
        className="btn btn-primary relative w-full py-3"
        disabled={processing}
        type="submit"
      >
        <span className="absolute inset-y-0 left-0 flex items-center pl-4">
          {processing ? (
            <ArrowPathIcon className="h-5 w-5 animate-spin" aria-hidden="true" />
          ) : (
            <EnvelopeIcon className="h-5 w-5" aria-hidden="true" />
          )}
        </span>
        <span className="font-medium">{processing ? "Sending magic link..." : "Continue with Email"}</span>
      </button>
    </form>
  );
}
